// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from '@hey-api/client-axios';
import { queryOptions, type UseMutationOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import { client, rootGet, getReleaseNotesGetReleaseNotesPost, uuidcheckUuidcheckPost, getAdminGetAdminPost, getAdminDataGetAdminDataPost, getAdminTypeGetAdminTypePost, updateRatingUpdateRatingPost, getPlanStatusGetPlanStatusPost, getIsSubscribedGetIsSubscribedPost, cancelPlanCancelPlanPost, changePlanChangePlanPost, getUserQuotaGetUserQuotaPost, getQueryParcelCountsGetQueryParcelCountsPost, setTutorialSetTutorialPost, signinSigninPost, signin2Signin2Post, trialVerifyEmailTrialVerifyEmailPost, trialResendOtpTrialResendOtpPost, trialVerifyOtpTrialVerifyOtpPost, trialDowngradePlanTrialDowngradePlanPost, enterpriseSalesInquiryEnterpriseSalesInquiryPost, getProfileGetProfilePost, deleteAccountDeleteAccountPost, twofactorauthTwofactorauthPost, sendUserMessageSendUserMessagePost, updateProfileUpdateProfilePost, changePasswordWithSessionKeyChangePasswordWithSessionKeyPost, updatePasswordUpdatePasswordPost, forgotPasswordForgotPasswordPost, createNewUserCreateNewUserPost, signupSignupPost, initialQueryParcelInitialQueryParcelPost, queryParcelQueryParcelPost, queryApnsUploadfileQueryApnsUploadfilePost, addInitialParcelToRanchAddInitialParcelToRanchPost, getsoilsgeomGetsoilsgeomPost, createRanchCreateRanchPost, editRanchEditRanchPost, getRanchesGetRanchesPost, getRanchesGeojsonGetRanchesGeojsonPost, addParcelToRanchAddParcelToRanchPost, deleteParcelFromRanchDeleteParcelFromRanchPost, deleteRanchDeleteRanchPost, getParcelsByRanchIdGetParcelsByRanchIdPost, querySoilsDetailUcdavisQuerySoilsDetailUcdavisPost, getSoilsPropsPtGetSoilsPropsPtPost, queryWatershedInfoPtQueryWatershedInfoPtPost, getAllLinksGetAllLinksPost, updateParcelsHsUpdateParcelsHsPost, getAllPortfolioSummariesGetAllPortfolioSummariesPost, getPortfolioSummaryGetPortfolioSummaryPost, getExecutiveSummaryGetExecutiveSummaryPost, insertReportInsertReportPost, generateReportDownloadTokenGenerateReportDownloadTokenPost, downloadReportDownloadReportTokenGet, getReportByRanchIdGetReportByRanchIdPost, getReportByReportIdGetReportByReportIdPost, getAllReportsGetAllReportsPost, getFloodFromWktGetFloodFromWktPost, getStateDistrictsGetStateDistrictsPost, getWeatherPlotsFromPtGetWeatherPlotsFromPtPost, getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPost, getDwrNewsGetDwrNewsGet, getDwrNewsJsonGetDwrNewsJsonGet, getDwrBlogsJsonGetDwrBlogsJsonGet, geocodeGeocodeGet, reverseGeocodeReverseGeocodeGet, autocompleteAutocompleteGet, placeDetailsPlaceDetailsGet, userFeedbackUserFeedbackPost, filterAutocompleteFilterAutocompletePost, apnAutocompleteApnAutocompletePost, getFilterCriteriaCountiesGetFilterCriteriaCountiesPost, filterCriteriaFilterCriteriaPost, createSubscriptionCreateSubscriptionPost, createCheckoutSessionCreateCheckoutSessionPost, stripeWebhookStripeWebhookPost, getEnterpriseAdminGetEnterpriseAdminGet, getOrganizationUsersOrganizationOrganizationIdUsersGet, createOrganizationUserOrganizationOrganizationIdUsersPost, exportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGet, importOrganizationUsersOrganizationOrganizationIdUsersImportPost, autocompleteOrganizationOrganizationIdUsersAutocompleteGet, getOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGet, updateOrganizationUserOrganizationOrganizationIdUsersUseruuidPut, updateOrganizationUserOrganizationOrganizationIdUsersUseruuidDelete, updateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPut, organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPost, resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPost, verifyInvitationVerifyInvitationTokenGet, getOrganizationInfoOrganizationInfoGet, updateOrganizationInfoOrganizationOrganizationIdUpdateInfoPut, updateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPut, addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPost, getPlaidLinkTokenGetPlaidLinkTokenGet, addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPost, removePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDelete, updateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPut, getBillingHistoryOrganizationOrganizationIdBillingHistoryGet, downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGet, socialiteCallBackSocialiteCallbackProviderPost, inAppVerifyReceiptInAppVerifyReceiptPost, appleNotificationAppleNotificationPost, appleNotificationTestAppleNotificationTestPost, appleNotificationTestAppleNotificationTestGet, googleNotificationGoogleNotificationPost, getPlanFeatureSettingsPlanFeatureSettingsGet, adminGetPlanFeatureSettingsAdminPlanFeatureSettingsGet, adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPost, updateUserNotifyHsChangeUsersNotifyHsChangePut } from '../services.gen';
import type { GetReleaseNotesGetReleaseNotesPostError, GetReleaseNotesGetReleaseNotesPostResponse, UuidcheckUuidcheckPostData, UuidcheckUuidcheckPostError, UuidcheckUuidcheckPostResponse, GetAdminGetAdminPostData, GetAdminGetAdminPostError, GetAdminGetAdminPostResponse, GetAdminDataGetAdminDataPostData, GetAdminDataGetAdminDataPostError, GetAdminDataGetAdminDataPostResponse, GetAdminTypeGetAdminTypePostData, GetAdminTypeGetAdminTypePostError, GetAdminTypeGetAdminTypePostResponse, UpdateRatingUpdateRatingPostData, UpdateRatingUpdateRatingPostError, UpdateRatingUpdateRatingPostResponse, GetPlanStatusGetPlanStatusPostData, GetPlanStatusGetPlanStatusPostError, GetPlanStatusGetPlanStatusPostResponse, GetIsSubscribedGetIsSubscribedPostData, GetIsSubscribedGetIsSubscribedPostError, GetIsSubscribedGetIsSubscribedPostResponse, CancelPlanCancelPlanPostData, CancelPlanCancelPlanPostError, CancelPlanCancelPlanPostResponse, ChangePlanChangePlanPostError, ChangePlanChangePlanPostResponse, GetUserQuotaGetUserQuotaPostData, GetUserQuotaGetUserQuotaPostError, GetUserQuotaGetUserQuotaPostResponse, GetQueryParcelCountsGetQueryParcelCountsPostData, GetQueryParcelCountsGetQueryParcelCountsPostError, GetQueryParcelCountsGetQueryParcelCountsPostResponse, SetTutorialSetTutorialPostData, SetTutorialSetTutorialPostError, SetTutorialSetTutorialPostResponse, SigninSigninPostData, SigninSigninPostError, SigninSigninPostResponse, Signin2Signin2PostData, Signin2Signin2PostError, Signin2Signin2PostResponse, TrialVerifyEmailTrialVerifyEmailPostData, TrialVerifyEmailTrialVerifyEmailPostError, TrialVerifyEmailTrialVerifyEmailPostResponse, TrialResendOtpTrialResendOtpPostData, TrialResendOtpTrialResendOtpPostError, TrialResendOtpTrialResendOtpPostResponse, TrialVerifyOtpTrialVerifyOtpPostData, TrialVerifyOtpTrialVerifyOtpPostError, TrialVerifyOtpTrialVerifyOtpPostResponse, TrialDowngradePlanTrialDowngradePlanPostData, TrialDowngradePlanTrialDowngradePlanPostError, TrialDowngradePlanTrialDowngradePlanPostResponse, EnterpriseSalesInquiryEnterpriseSalesInquiryPostData, EnterpriseSalesInquiryEnterpriseSalesInquiryPostError, EnterpriseSalesInquiryEnterpriseSalesInquiryPostResponse, GetProfileGetProfilePostData, GetProfileGetProfilePostError, GetProfileGetProfilePostResponse, DeleteAccountDeleteAccountPostData, DeleteAccountDeleteAccountPostError, DeleteAccountDeleteAccountPostResponse, TwofactorauthTwofactorauthPostData, TwofactorauthTwofactorauthPostError, TwofactorauthTwofactorauthPostResponse, SendUserMessageSendUserMessagePostData, SendUserMessageSendUserMessagePostError, SendUserMessageSendUserMessagePostResponse, UpdateProfileUpdateProfilePostData, UpdateProfileUpdateProfilePostError, UpdateProfileUpdateProfilePostResponse, ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostData, ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostError, ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostResponse, UpdatePasswordUpdatePasswordPostData, UpdatePasswordUpdatePasswordPostError, UpdatePasswordUpdatePasswordPostResponse, ForgotPasswordForgotPasswordPostData, ForgotPasswordForgotPasswordPostError, ForgotPasswordForgotPasswordPostResponse, CreateNewUserCreateNewUserPostData, CreateNewUserCreateNewUserPostError, CreateNewUserCreateNewUserPostResponse, SignupSignupPostData, SignupSignupPostError, SignupSignupPostResponse, InitialQueryParcelInitialQueryParcelPostData, InitialQueryParcelInitialQueryParcelPostError, InitialQueryParcelInitialQueryParcelPostResponse, QueryParcelQueryParcelPostData, QueryParcelQueryParcelPostError, QueryParcelQueryParcelPostResponse, QueryApnsUploadfileQueryApnsUploadfilePostData, QueryApnsUploadfileQueryApnsUploadfilePostError, QueryApnsUploadfileQueryApnsUploadfilePostResponse, AddInitialParcelToRanchAddInitialParcelToRanchPostData, AddInitialParcelToRanchAddInitialParcelToRanchPostError, AddInitialParcelToRanchAddInitialParcelToRanchPostResponse, GetsoilsgeomGetsoilsgeomPostData, GetsoilsgeomGetsoilsgeomPostError, GetsoilsgeomGetsoilsgeomPostResponse, CreateRanchCreateRanchPostData, CreateRanchCreateRanchPostError, CreateRanchCreateRanchPostResponse, EditRanchEditRanchPostData, EditRanchEditRanchPostError, EditRanchEditRanchPostResponse, GetRanchesGetRanchesPostData, GetRanchesGetRanchesPostError, GetRanchesGetRanchesPostResponse, GetRanchesGeojsonGetRanchesGeojsonPostData, GetRanchesGeojsonGetRanchesGeojsonPostError, GetRanchesGeojsonGetRanchesGeojsonPostResponse, AddParcelToRanchAddParcelToRanchPostData, AddParcelToRanchAddParcelToRanchPostError, AddParcelToRanchAddParcelToRanchPostResponse, DeleteParcelFromRanchDeleteParcelFromRanchPostData, DeleteParcelFromRanchDeleteParcelFromRanchPostError, DeleteParcelFromRanchDeleteParcelFromRanchPostResponse, DeleteRanchDeleteRanchPostData, DeleteRanchDeleteRanchPostError, DeleteRanchDeleteRanchPostResponse, GetParcelsByRanchIdGetParcelsByRanchIdPostData, GetParcelsByRanchIdGetParcelsByRanchIdPostError, GetParcelsByRanchIdGetParcelsByRanchIdPostResponse, QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostData, QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostError, QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostResponse, GetSoilsPropsPtGetSoilsPropsPtPostData, GetSoilsPropsPtGetSoilsPropsPtPostError, GetSoilsPropsPtGetSoilsPropsPtPostResponse, QueryWatershedInfoPtQueryWatershedInfoPtPostData, QueryWatershedInfoPtQueryWatershedInfoPtPostError, QueryWatershedInfoPtQueryWatershedInfoPtPostResponse, GetAllLinksGetAllLinksPostData, GetAllLinksGetAllLinksPostError, GetAllLinksGetAllLinksPostResponse, UpdateParcelsHsUpdateParcelsHsPostData, UpdateParcelsHsUpdateParcelsHsPostError, UpdateParcelsHsUpdateParcelsHsPostResponse, GetAllPortfolioSummariesGetAllPortfolioSummariesPostError, GetAllPortfolioSummariesGetAllPortfolioSummariesPostResponse, GetPortfolioSummaryGetPortfolioSummaryPostData, GetPortfolioSummaryGetPortfolioSummaryPostError, GetPortfolioSummaryGetPortfolioSummaryPostResponse, GetExecutiveSummaryGetExecutiveSummaryPostData, GetExecutiveSummaryGetExecutiveSummaryPostError, GetExecutiveSummaryGetExecutiveSummaryPostResponse, InsertReportInsertReportPostData, InsertReportInsertReportPostError, InsertReportInsertReportPostResponse, GenerateReportDownloadTokenGenerateReportDownloadTokenPostData, GenerateReportDownloadTokenGenerateReportDownloadTokenPostError, GenerateReportDownloadTokenGenerateReportDownloadTokenPostResponse, DownloadReportDownloadReportTokenGetData, GetReportByRanchIdGetReportByRanchIdPostData, GetReportByRanchIdGetReportByRanchIdPostError, GetReportByRanchIdGetReportByRanchIdPostResponse, GetReportByReportIdGetReportByReportIdPostData, GetReportByReportIdGetReportByReportIdPostError, GetReportByReportIdGetReportByReportIdPostResponse, GetAllReportsGetAllReportsPostData, GetAllReportsGetAllReportsPostError, GetAllReportsGetAllReportsPostResponse, GetFloodFromWktGetFloodFromWktPostData, GetFloodFromWktGetFloodFromWktPostError, GetFloodFromWktGetFloodFromWktPostResponse, GetStateDistrictsGetStateDistrictsPostData, GetStateDistrictsGetStateDistrictsPostError, GetStateDistrictsGetStateDistrictsPostResponse, GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostData, GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostError, GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostResponse, GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostData, GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostError, GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostResponse, GeocodeGeocodeGetData, ReverseGeocodeReverseGeocodeGetData, AutocompleteAutocompleteGetData, PlaceDetailsPlaceDetailsGetData, UserFeedbackUserFeedbackPostData, UserFeedbackUserFeedbackPostError, UserFeedbackUserFeedbackPostResponse, FilterAutocompleteFilterAutocompletePostData, FilterAutocompleteFilterAutocompletePostError, FilterAutocompleteFilterAutocompletePostResponse, ApnAutocompleteApnAutocompletePostData, ApnAutocompleteApnAutocompletePostError, ApnAutocompleteApnAutocompletePostResponse, GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostError, GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostResponse, FilterCriteriaFilterCriteriaPostData, FilterCriteriaFilterCriteriaPostError, FilterCriteriaFilterCriteriaPostResponse, CreateSubscriptionCreateSubscriptionPostError, CreateSubscriptionCreateSubscriptionPostResponse, CreateCheckoutSessionCreateCheckoutSessionPostError, CreateCheckoutSessionCreateCheckoutSessionPostResponse, StripeWebhookStripeWebhookPostError, StripeWebhookStripeWebhookPostResponse, GetOrganizationUsersOrganizationOrganizationIdUsersGetData, GetOrganizationUsersOrganizationOrganizationIdUsersGetError, GetOrganizationUsersOrganizationOrganizationIdUsersGetResponse, CreateOrganizationUserOrganizationOrganizationIdUsersPostData, CreateOrganizationUserOrganizationOrganizationIdUsersPostError, CreateOrganizationUserOrganizationOrganizationIdUsersPostResponse, ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetData, ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostData, ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostError, ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostResponse, AutocompleteOrganizationOrganizationIdUsersAutocompleteGetData, GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetData, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutData, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutError, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutResponse, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteData, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteError, UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteResponse, UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutData, UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutError, UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutResponse, OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostData, OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostError, OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostResponse, ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostData, ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostError, ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostResponse, VerifyInvitationVerifyInvitationTokenGetData, UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutData, UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutError, UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutResponse, UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutData, UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutError, UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutResponse, AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostData, AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostError, AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostResponse, AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostData, AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostError, AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostResponse, RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteData, RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteError, RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteResponse, UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutData, UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutError, UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutResponse, GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetData, DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetData, SocialiteCallBackSocialiteCallbackProviderPostData, SocialiteCallBackSocialiteCallbackProviderPostError, SocialiteCallBackSocialiteCallbackProviderPostResponse, InAppVerifyReceiptInAppVerifyReceiptPostData, InAppVerifyReceiptInAppVerifyReceiptPostError, InAppVerifyReceiptInAppVerifyReceiptPostResponse, AppleNotificationAppleNotificationPostError, AppleNotificationAppleNotificationPostResponse, AppleNotificationTestAppleNotificationTestPostError, AppleNotificationTestAppleNotificationTestPostResponse, AppleNotificationTestAppleNotificationTestGetData, GoogleNotificationGoogleNotificationPostError, GoogleNotificationGoogleNotificationPostResponse, AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostData, AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostError, AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostResponse, UpdateUserNotifyHsChangeUsersNotifyHsChangePutData, UpdateUserNotifyHsChangeUsersNotifyHsChangePutError, UpdateUserNotifyHsChangeUsersNotifyHsChangePutResponse } from '../types.gen';
import type { AxiosError } from 'axios';

type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): QueryKey<TOptions>[0] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return params;
};

export const rootGetQueryKey = (options?: Options) => [
    createQueryKey('rootGet', options)
];

export const rootGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await rootGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rootGetQueryKey(options)
    });
};

export const getReleaseNotesGetReleaseNotesPostQueryKey = (options?: Options) => [
    createQueryKey('getReleaseNotesGetReleaseNotesPost', options)
];

export const getReleaseNotesGetReleaseNotesPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReleaseNotesGetReleaseNotesPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getReleaseNotesGetReleaseNotesPostQueryKey(options)
    });
};

export const getReleaseNotesGetReleaseNotesPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<GetReleaseNotesGetReleaseNotesPostResponse, AxiosError<GetReleaseNotesGetReleaseNotesPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await getReleaseNotesGetReleaseNotesPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const uuidcheckUuidcheckPostQueryKey = (options: Options<UuidcheckUuidcheckPostData>) => [
    createQueryKey('uuidcheckUuidcheckPost', options)
];

export const uuidcheckUuidcheckPostOptions = (options: Options<UuidcheckUuidcheckPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await uuidcheckUuidcheckPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: uuidcheckUuidcheckPostQueryKey(options)
    });
};

export const uuidcheckUuidcheckPostMutation = (options?: Partial<Options<UuidcheckUuidcheckPostData>>) => {
    const mutationOptions: UseMutationOptions<UuidcheckUuidcheckPostResponse, AxiosError<UuidcheckUuidcheckPostError>, Options<UuidcheckUuidcheckPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await uuidcheckUuidcheckPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminGetAdminPostQueryKey = (options: Options<GetAdminGetAdminPostData>) => [
    createQueryKey('getAdminGetAdminPost', options)
];

export const getAdminGetAdminPostOptions = (options: Options<GetAdminGetAdminPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminGetAdminPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAdminGetAdminPostQueryKey(options)
    });
};

export const getAdminGetAdminPostMutation = (options?: Partial<Options<GetAdminGetAdminPostData>>) => {
    const mutationOptions: UseMutationOptions<GetAdminGetAdminPostResponse, AxiosError<GetAdminGetAdminPostError>, Options<GetAdminGetAdminPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getAdminGetAdminPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminDataGetAdminDataPostQueryKey = (options: Options<GetAdminDataGetAdminDataPostData>) => [
    createQueryKey('getAdminDataGetAdminDataPost', options)
];

export const getAdminDataGetAdminDataPostOptions = (options: Options<GetAdminDataGetAdminDataPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminDataGetAdminDataPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAdminDataGetAdminDataPostQueryKey(options)
    });
};

export const getAdminDataGetAdminDataPostMutation = (options?: Partial<Options<GetAdminDataGetAdminDataPostData>>) => {
    const mutationOptions: UseMutationOptions<GetAdminDataGetAdminDataPostResponse, AxiosError<GetAdminDataGetAdminDataPostError>, Options<GetAdminDataGetAdminDataPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getAdminDataGetAdminDataPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminTypeGetAdminTypePostQueryKey = (options: Options<GetAdminTypeGetAdminTypePostData>) => [
    createQueryKey('getAdminTypeGetAdminTypePost', options)
];

export const getAdminTypeGetAdminTypePostOptions = (options: Options<GetAdminTypeGetAdminTypePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminTypeGetAdminTypePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAdminTypeGetAdminTypePostQueryKey(options)
    });
};

export const getAdminTypeGetAdminTypePostMutation = (options?: Partial<Options<GetAdminTypeGetAdminTypePostData>>) => {
    const mutationOptions: UseMutationOptions<GetAdminTypeGetAdminTypePostResponse, AxiosError<GetAdminTypeGetAdminTypePostError>, Options<GetAdminTypeGetAdminTypePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getAdminTypeGetAdminTypePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateRatingUpdateRatingPostQueryKey = (options: Options<UpdateRatingUpdateRatingPostData>) => [
    createQueryKey('updateRatingUpdateRatingPost', options)
];

export const updateRatingUpdateRatingPostOptions = (options: Options<UpdateRatingUpdateRatingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await updateRatingUpdateRatingPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: updateRatingUpdateRatingPostQueryKey(options)
    });
};

export const updateRatingUpdateRatingPostMutation = (options?: Partial<Options<UpdateRatingUpdateRatingPostData>>) => {
    const mutationOptions: UseMutationOptions<UpdateRatingUpdateRatingPostResponse, AxiosError<UpdateRatingUpdateRatingPostError>, Options<UpdateRatingUpdateRatingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateRatingUpdateRatingPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPlanStatusGetPlanStatusPostQueryKey = (options: Options<GetPlanStatusGetPlanStatusPostData>) => [
    createQueryKey('getPlanStatusGetPlanStatusPost', options)
];

export const getPlanStatusGetPlanStatusPostOptions = (options: Options<GetPlanStatusGetPlanStatusPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlanStatusGetPlanStatusPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPlanStatusGetPlanStatusPostQueryKey(options)
    });
};

export const getPlanStatusGetPlanStatusPostMutation = (options?: Partial<Options<GetPlanStatusGetPlanStatusPostData>>) => {
    const mutationOptions: UseMutationOptions<GetPlanStatusGetPlanStatusPostResponse, AxiosError<GetPlanStatusGetPlanStatusPostError>, Options<GetPlanStatusGetPlanStatusPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getPlanStatusGetPlanStatusPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIsSubscribedGetIsSubscribedPostQueryKey = (options: Options<GetIsSubscribedGetIsSubscribedPostData>) => [
    createQueryKey('getIsSubscribedGetIsSubscribedPost', options)
];

export const getIsSubscribedGetIsSubscribedPostOptions = (options: Options<GetIsSubscribedGetIsSubscribedPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIsSubscribedGetIsSubscribedPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getIsSubscribedGetIsSubscribedPostQueryKey(options)
    });
};

export const getIsSubscribedGetIsSubscribedPostMutation = (options?: Partial<Options<GetIsSubscribedGetIsSubscribedPostData>>) => {
    const mutationOptions: UseMutationOptions<GetIsSubscribedGetIsSubscribedPostResponse, AxiosError<GetIsSubscribedGetIsSubscribedPostError>, Options<GetIsSubscribedGetIsSubscribedPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getIsSubscribedGetIsSubscribedPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const cancelPlanCancelPlanPostQueryKey = (options: Options<CancelPlanCancelPlanPostData>) => [
    createQueryKey('cancelPlanCancelPlanPost', options)
];

export const cancelPlanCancelPlanPostOptions = (options: Options<CancelPlanCancelPlanPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cancelPlanCancelPlanPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: cancelPlanCancelPlanPostQueryKey(options)
    });
};

export const cancelPlanCancelPlanPostMutation = (options?: Partial<Options<CancelPlanCancelPlanPostData>>) => {
    const mutationOptions: UseMutationOptions<CancelPlanCancelPlanPostResponse, AxiosError<CancelPlanCancelPlanPostError>, Options<CancelPlanCancelPlanPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await cancelPlanCancelPlanPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const changePlanChangePlanPostQueryKey = (options?: Options) => [
    createQueryKey('changePlanChangePlanPost', options)
];

export const changePlanChangePlanPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await changePlanChangePlanPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: changePlanChangePlanPostQueryKey(options)
    });
};

export const changePlanChangePlanPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<ChangePlanChangePlanPostResponse, AxiosError<ChangePlanChangePlanPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await changePlanChangePlanPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserQuotaGetUserQuotaPostQueryKey = (options: Options<GetUserQuotaGetUserQuotaPostData>) => [
    createQueryKey('getUserQuotaGetUserQuotaPost', options)
];

export const getUserQuotaGetUserQuotaPostOptions = (options: Options<GetUserQuotaGetUserQuotaPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserQuotaGetUserQuotaPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserQuotaGetUserQuotaPostQueryKey(options)
    });
};

export const getUserQuotaGetUserQuotaPostMutation = (options?: Partial<Options<GetUserQuotaGetUserQuotaPostData>>) => {
    const mutationOptions: UseMutationOptions<GetUserQuotaGetUserQuotaPostResponse, AxiosError<GetUserQuotaGetUserQuotaPostError>, Options<GetUserQuotaGetUserQuotaPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getUserQuotaGetUserQuotaPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQueryParcelCountsGetQueryParcelCountsPostQueryKey = (options: Options<GetQueryParcelCountsGetQueryParcelCountsPostData>) => [
    createQueryKey('getQueryParcelCountsGetQueryParcelCountsPost', options)
];

export const getQueryParcelCountsGetQueryParcelCountsPostOptions = (options: Options<GetQueryParcelCountsGetQueryParcelCountsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getQueryParcelCountsGetQueryParcelCountsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getQueryParcelCountsGetQueryParcelCountsPostQueryKey(options)
    });
};

export const getQueryParcelCountsGetQueryParcelCountsPostMutation = (options?: Partial<Options<GetQueryParcelCountsGetQueryParcelCountsPostData>>) => {
    const mutationOptions: UseMutationOptions<GetQueryParcelCountsGetQueryParcelCountsPostResponse, AxiosError<GetQueryParcelCountsGetQueryParcelCountsPostError>, Options<GetQueryParcelCountsGetQueryParcelCountsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getQueryParcelCountsGetQueryParcelCountsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setTutorialSetTutorialPostQueryKey = (options: Options<SetTutorialSetTutorialPostData>) => [
    createQueryKey('setTutorialSetTutorialPost', options)
];

export const setTutorialSetTutorialPostOptions = (options: Options<SetTutorialSetTutorialPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setTutorialSetTutorialPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setTutorialSetTutorialPostQueryKey(options)
    });
};

export const setTutorialSetTutorialPostMutation = (options?: Partial<Options<SetTutorialSetTutorialPostData>>) => {
    const mutationOptions: UseMutationOptions<SetTutorialSetTutorialPostResponse, AxiosError<SetTutorialSetTutorialPostError>, Options<SetTutorialSetTutorialPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await setTutorialSetTutorialPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const signinSigninPostQueryKey = (options: Options<SigninSigninPostData>) => [
    createQueryKey('signinSigninPost', options)
];

export const signinSigninPostOptions = (options: Options<SigninSigninPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await signinSigninPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: signinSigninPostQueryKey(options)
    });
};

export const signinSigninPostMutation = (options?: Partial<Options<SigninSigninPostData>>) => {
    const mutationOptions: UseMutationOptions<SigninSigninPostResponse, AxiosError<SigninSigninPostError>, Options<SigninSigninPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await signinSigninPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const signin2Signin2PostQueryKey = (options: Options<Signin2Signin2PostData>) => [
    createQueryKey('signin2Signin2Post', options)
];

export const signin2Signin2PostOptions = (options: Options<Signin2Signin2PostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await signin2Signin2Post({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: signin2Signin2PostQueryKey(options)
    });
};

export const signin2Signin2PostMutation = (options?: Partial<Options<Signin2Signin2PostData>>) => {
    const mutationOptions: UseMutationOptions<Signin2Signin2PostResponse, AxiosError<Signin2Signin2PostError>, Options<Signin2Signin2PostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await signin2Signin2Post({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trialVerifyEmailTrialVerifyEmailPostQueryKey = (options: Options<TrialVerifyEmailTrialVerifyEmailPostData>) => [
    createQueryKey('trialVerifyEmailTrialVerifyEmailPost', options)
];

export const trialVerifyEmailTrialVerifyEmailPostOptions = (options: Options<TrialVerifyEmailTrialVerifyEmailPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trialVerifyEmailTrialVerifyEmailPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trialVerifyEmailTrialVerifyEmailPostQueryKey(options)
    });
};

export const trialVerifyEmailTrialVerifyEmailPostMutation = (options?: Partial<Options<TrialVerifyEmailTrialVerifyEmailPostData>>) => {
    const mutationOptions: UseMutationOptions<TrialVerifyEmailTrialVerifyEmailPostResponse, AxiosError<TrialVerifyEmailTrialVerifyEmailPostError>, Options<TrialVerifyEmailTrialVerifyEmailPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trialVerifyEmailTrialVerifyEmailPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trialResendOtpTrialResendOtpPostQueryKey = (options: Options<TrialResendOtpTrialResendOtpPostData>) => [
    createQueryKey('trialResendOtpTrialResendOtpPost', options)
];

export const trialResendOtpTrialResendOtpPostOptions = (options: Options<TrialResendOtpTrialResendOtpPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trialResendOtpTrialResendOtpPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trialResendOtpTrialResendOtpPostQueryKey(options)
    });
};

export const trialResendOtpTrialResendOtpPostMutation = (options?: Partial<Options<TrialResendOtpTrialResendOtpPostData>>) => {
    const mutationOptions: UseMutationOptions<TrialResendOtpTrialResendOtpPostResponse, AxiosError<TrialResendOtpTrialResendOtpPostError>, Options<TrialResendOtpTrialResendOtpPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trialResendOtpTrialResendOtpPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trialVerifyOtpTrialVerifyOtpPostQueryKey = (options: Options<TrialVerifyOtpTrialVerifyOtpPostData>) => [
    createQueryKey('trialVerifyOtpTrialVerifyOtpPost', options)
];

export const trialVerifyOtpTrialVerifyOtpPostOptions = (options: Options<TrialVerifyOtpTrialVerifyOtpPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trialVerifyOtpTrialVerifyOtpPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trialVerifyOtpTrialVerifyOtpPostQueryKey(options)
    });
};

export const trialVerifyOtpTrialVerifyOtpPostMutation = (options?: Partial<Options<TrialVerifyOtpTrialVerifyOtpPostData>>) => {
    const mutationOptions: UseMutationOptions<TrialVerifyOtpTrialVerifyOtpPostResponse, AxiosError<TrialVerifyOtpTrialVerifyOtpPostError>, Options<TrialVerifyOtpTrialVerifyOtpPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trialVerifyOtpTrialVerifyOtpPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const trialDowngradePlanTrialDowngradePlanPostQueryKey = (options: Options<TrialDowngradePlanTrialDowngradePlanPostData>) => [
    createQueryKey('trialDowngradePlanTrialDowngradePlanPost', options)
];

export const trialDowngradePlanTrialDowngradePlanPostOptions = (options: Options<TrialDowngradePlanTrialDowngradePlanPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await trialDowngradePlanTrialDowngradePlanPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: trialDowngradePlanTrialDowngradePlanPostQueryKey(options)
    });
};

export const trialDowngradePlanTrialDowngradePlanPostMutation = (options?: Partial<Options<TrialDowngradePlanTrialDowngradePlanPostData>>) => {
    const mutationOptions: UseMutationOptions<TrialDowngradePlanTrialDowngradePlanPostResponse, AxiosError<TrialDowngradePlanTrialDowngradePlanPostError>, Options<TrialDowngradePlanTrialDowngradePlanPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await trialDowngradePlanTrialDowngradePlanPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enterpriseSalesInquiryEnterpriseSalesInquiryPostQueryKey = (options: Options<EnterpriseSalesInquiryEnterpriseSalesInquiryPostData>) => [
    createQueryKey('enterpriseSalesInquiryEnterpriseSalesInquiryPost', options)
];

export const enterpriseSalesInquiryEnterpriseSalesInquiryPostOptions = (options: Options<EnterpriseSalesInquiryEnterpriseSalesInquiryPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await enterpriseSalesInquiryEnterpriseSalesInquiryPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: enterpriseSalesInquiryEnterpriseSalesInquiryPostQueryKey(options)
    });
};

export const enterpriseSalesInquiryEnterpriseSalesInquiryPostMutation = (options?: Partial<Options<EnterpriseSalesInquiryEnterpriseSalesInquiryPostData>>) => {
    const mutationOptions: UseMutationOptions<EnterpriseSalesInquiryEnterpriseSalesInquiryPostResponse, AxiosError<EnterpriseSalesInquiryEnterpriseSalesInquiryPostError>, Options<EnterpriseSalesInquiryEnterpriseSalesInquiryPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await enterpriseSalesInquiryEnterpriseSalesInquiryPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProfileGetProfilePostQueryKey = (options: Options<GetProfileGetProfilePostData>) => [
    createQueryKey('getProfileGetProfilePost', options)
];

export const getProfileGetProfilePostOptions = (options: Options<GetProfileGetProfilePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProfileGetProfilePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProfileGetProfilePostQueryKey(options)
    });
};

export const getProfileGetProfilePostMutation = (options?: Partial<Options<GetProfileGetProfilePostData>>) => {
    const mutationOptions: UseMutationOptions<GetProfileGetProfilePostResponse, AxiosError<GetProfileGetProfilePostError>, Options<GetProfileGetProfilePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getProfileGetProfilePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteAccountDeleteAccountPostQueryKey = (options: Options<DeleteAccountDeleteAccountPostData>) => [
    createQueryKey('deleteAccountDeleteAccountPost', options)
];

export const deleteAccountDeleteAccountPostOptions = (options: Options<DeleteAccountDeleteAccountPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await deleteAccountDeleteAccountPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: deleteAccountDeleteAccountPostQueryKey(options)
    });
};

export const deleteAccountDeleteAccountPostMutation = (options?: Partial<Options<DeleteAccountDeleteAccountPostData>>) => {
    const mutationOptions: UseMutationOptions<DeleteAccountDeleteAccountPostResponse, AxiosError<DeleteAccountDeleteAccountPostError>, Options<DeleteAccountDeleteAccountPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteAccountDeleteAccountPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const twofactorauthTwofactorauthPostQueryKey = (options: Options<TwofactorauthTwofactorauthPostData>) => [
    createQueryKey('twofactorauthTwofactorauthPost', options)
];

export const twofactorauthTwofactorauthPostOptions = (options: Options<TwofactorauthTwofactorauthPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await twofactorauthTwofactorauthPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: twofactorauthTwofactorauthPostQueryKey(options)
    });
};

export const twofactorauthTwofactorauthPostMutation = (options?: Partial<Options<TwofactorauthTwofactorauthPostData>>) => {
    const mutationOptions: UseMutationOptions<TwofactorauthTwofactorauthPostResponse, AxiosError<TwofactorauthTwofactorauthPostError>, Options<TwofactorauthTwofactorauthPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await twofactorauthTwofactorauthPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sendUserMessageSendUserMessagePostQueryKey = (options: Options<SendUserMessageSendUserMessagePostData>) => [
    createQueryKey('sendUserMessageSendUserMessagePost', options)
];

export const sendUserMessageSendUserMessagePostOptions = (options: Options<SendUserMessageSendUserMessagePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await sendUserMessageSendUserMessagePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: sendUserMessageSendUserMessagePostQueryKey(options)
    });
};

export const sendUserMessageSendUserMessagePostMutation = (options?: Partial<Options<SendUserMessageSendUserMessagePostData>>) => {
    const mutationOptions: UseMutationOptions<SendUserMessageSendUserMessagePostResponse, AxiosError<SendUserMessageSendUserMessagePostError>, Options<SendUserMessageSendUserMessagePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await sendUserMessageSendUserMessagePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateProfileUpdateProfilePostQueryKey = (options: Options<UpdateProfileUpdateProfilePostData>) => [
    createQueryKey('updateProfileUpdateProfilePost', options)
];

export const updateProfileUpdateProfilePostOptions = (options: Options<UpdateProfileUpdateProfilePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await updateProfileUpdateProfilePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: updateProfileUpdateProfilePostQueryKey(options)
    });
};

export const updateProfileUpdateProfilePostMutation = (options?: Partial<Options<UpdateProfileUpdateProfilePostData>>) => {
    const mutationOptions: UseMutationOptions<UpdateProfileUpdateProfilePostResponse, AxiosError<UpdateProfileUpdateProfilePostError>, Options<UpdateProfileUpdateProfilePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateProfileUpdateProfilePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const changePasswordWithSessionKeyChangePasswordWithSessionKeyPostQueryKey = (options: Options<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostData>) => [
    createQueryKey('changePasswordWithSessionKeyChangePasswordWithSessionKeyPost', options)
];

export const changePasswordWithSessionKeyChangePasswordWithSessionKeyPostOptions = (options: Options<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await changePasswordWithSessionKeyChangePasswordWithSessionKeyPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: changePasswordWithSessionKeyChangePasswordWithSessionKeyPostQueryKey(options)
    });
};

export const changePasswordWithSessionKeyChangePasswordWithSessionKeyPostMutation = (options?: Partial<Options<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostData>>) => {
    const mutationOptions: UseMutationOptions<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostResponse, AxiosError<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostError>, Options<ChangePasswordWithSessionKeyChangePasswordWithSessionKeyPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await changePasswordWithSessionKeyChangePasswordWithSessionKeyPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updatePasswordUpdatePasswordPostQueryKey = (options: Options<UpdatePasswordUpdatePasswordPostData>) => [
    createQueryKey('updatePasswordUpdatePasswordPost', options)
];

export const updatePasswordUpdatePasswordPostOptions = (options: Options<UpdatePasswordUpdatePasswordPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await updatePasswordUpdatePasswordPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: updatePasswordUpdatePasswordPostQueryKey(options)
    });
};

export const updatePasswordUpdatePasswordPostMutation = (options?: Partial<Options<UpdatePasswordUpdatePasswordPostData>>) => {
    const mutationOptions: UseMutationOptions<UpdatePasswordUpdatePasswordPostResponse, AxiosError<UpdatePasswordUpdatePasswordPostError>, Options<UpdatePasswordUpdatePasswordPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updatePasswordUpdatePasswordPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const forgotPasswordForgotPasswordPostQueryKey = (options: Options<ForgotPasswordForgotPasswordPostData>) => [
    createQueryKey('forgotPasswordForgotPasswordPost', options)
];

export const forgotPasswordForgotPasswordPostOptions = (options: Options<ForgotPasswordForgotPasswordPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await forgotPasswordForgotPasswordPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: forgotPasswordForgotPasswordPostQueryKey(options)
    });
};

export const forgotPasswordForgotPasswordPostMutation = (options?: Partial<Options<ForgotPasswordForgotPasswordPostData>>) => {
    const mutationOptions: UseMutationOptions<ForgotPasswordForgotPasswordPostResponse, AxiosError<ForgotPasswordForgotPasswordPostError>, Options<ForgotPasswordForgotPasswordPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await forgotPasswordForgotPasswordPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createNewUserCreateNewUserPostQueryKey = (options: Options<CreateNewUserCreateNewUserPostData>) => [
    createQueryKey('createNewUserCreateNewUserPost', options)
];

export const createNewUserCreateNewUserPostOptions = (options: Options<CreateNewUserCreateNewUserPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createNewUserCreateNewUserPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createNewUserCreateNewUserPostQueryKey(options)
    });
};

export const createNewUserCreateNewUserPostMutation = (options?: Partial<Options<CreateNewUserCreateNewUserPostData>>) => {
    const mutationOptions: UseMutationOptions<CreateNewUserCreateNewUserPostResponse, AxiosError<CreateNewUserCreateNewUserPostError>, Options<CreateNewUserCreateNewUserPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createNewUserCreateNewUserPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const signupSignupPostQueryKey = (options: Options<SignupSignupPostData>) => [
    createQueryKey('signupSignupPost', options)
];

export const signupSignupPostOptions = (options: Options<SignupSignupPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await signupSignupPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: signupSignupPostQueryKey(options)
    });
};

export const signupSignupPostMutation = (options?: Partial<Options<SignupSignupPostData>>) => {
    const mutationOptions: UseMutationOptions<SignupSignupPostResponse, AxiosError<SignupSignupPostError>, Options<SignupSignupPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await signupSignupPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const initialQueryParcelInitialQueryParcelPostQueryKey = (options: Options<InitialQueryParcelInitialQueryParcelPostData>) => [
    createQueryKey('initialQueryParcelInitialQueryParcelPost', options)
];

export const initialQueryParcelInitialQueryParcelPostOptions = (options: Options<InitialQueryParcelInitialQueryParcelPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await initialQueryParcelInitialQueryParcelPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: initialQueryParcelInitialQueryParcelPostQueryKey(options)
    });
};

export const initialQueryParcelInitialQueryParcelPostMutation = (options?: Partial<Options<InitialQueryParcelInitialQueryParcelPostData>>) => {
    const mutationOptions: UseMutationOptions<InitialQueryParcelInitialQueryParcelPostResponse, AxiosError<InitialQueryParcelInitialQueryParcelPostError>, Options<InitialQueryParcelInitialQueryParcelPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await initialQueryParcelInitialQueryParcelPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const queryParcelQueryParcelPostQueryKey = (options: Options<QueryParcelQueryParcelPostData>) => [
    createQueryKey('queryParcelQueryParcelPost', options)
];

export const queryParcelQueryParcelPostOptions = (options: Options<QueryParcelQueryParcelPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await queryParcelQueryParcelPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: queryParcelQueryParcelPostQueryKey(options)
    });
};

export const queryParcelQueryParcelPostMutation = (options?: Partial<Options<QueryParcelQueryParcelPostData>>) => {
    const mutationOptions: UseMutationOptions<QueryParcelQueryParcelPostResponse, AxiosError<QueryParcelQueryParcelPostError>, Options<QueryParcelQueryParcelPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await queryParcelQueryParcelPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const queryApnsUploadfileQueryApnsUploadfilePostQueryKey = (options: Options<QueryApnsUploadfileQueryApnsUploadfilePostData>) => [
    createQueryKey('queryApnsUploadfileQueryApnsUploadfilePost', options)
];

export const queryApnsUploadfileQueryApnsUploadfilePostOptions = (options: Options<QueryApnsUploadfileQueryApnsUploadfilePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await queryApnsUploadfileQueryApnsUploadfilePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: queryApnsUploadfileQueryApnsUploadfilePostQueryKey(options)
    });
};

export const queryApnsUploadfileQueryApnsUploadfilePostMutation = (options?: Partial<Options<QueryApnsUploadfileQueryApnsUploadfilePostData>>) => {
    const mutationOptions: UseMutationOptions<QueryApnsUploadfileQueryApnsUploadfilePostResponse, AxiosError<QueryApnsUploadfileQueryApnsUploadfilePostError>, Options<QueryApnsUploadfileQueryApnsUploadfilePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await queryApnsUploadfileQueryApnsUploadfilePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addInitialParcelToRanchAddInitialParcelToRanchPostQueryKey = (options: Options<AddInitialParcelToRanchAddInitialParcelToRanchPostData>) => [
    createQueryKey('addInitialParcelToRanchAddInitialParcelToRanchPost', options)
];

export const addInitialParcelToRanchAddInitialParcelToRanchPostOptions = (options: Options<AddInitialParcelToRanchAddInitialParcelToRanchPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addInitialParcelToRanchAddInitialParcelToRanchPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addInitialParcelToRanchAddInitialParcelToRanchPostQueryKey(options)
    });
};

export const addInitialParcelToRanchAddInitialParcelToRanchPostMutation = (options?: Partial<Options<AddInitialParcelToRanchAddInitialParcelToRanchPostData>>) => {
    const mutationOptions: UseMutationOptions<AddInitialParcelToRanchAddInitialParcelToRanchPostResponse, AxiosError<AddInitialParcelToRanchAddInitialParcelToRanchPostError>, Options<AddInitialParcelToRanchAddInitialParcelToRanchPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addInitialParcelToRanchAddInitialParcelToRanchPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getsoilsgeomGetsoilsgeomPostQueryKey = (options: Options<GetsoilsgeomGetsoilsgeomPostData>) => [
    createQueryKey('getsoilsgeomGetsoilsgeomPost', options)
];

export const getsoilsgeomGetsoilsgeomPostOptions = (options: Options<GetsoilsgeomGetsoilsgeomPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getsoilsgeomGetsoilsgeomPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getsoilsgeomGetsoilsgeomPostQueryKey(options)
    });
};

export const getsoilsgeomGetsoilsgeomPostMutation = (options?: Partial<Options<GetsoilsgeomGetsoilsgeomPostData>>) => {
    const mutationOptions: UseMutationOptions<GetsoilsgeomGetsoilsgeomPostResponse, AxiosError<GetsoilsgeomGetsoilsgeomPostError>, Options<GetsoilsgeomGetsoilsgeomPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getsoilsgeomGetsoilsgeomPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createRanchCreateRanchPostQueryKey = (options: Options<CreateRanchCreateRanchPostData>) => [
    createQueryKey('createRanchCreateRanchPost', options)
];

export const createRanchCreateRanchPostOptions = (options: Options<CreateRanchCreateRanchPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createRanchCreateRanchPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createRanchCreateRanchPostQueryKey(options)
    });
};

export const createRanchCreateRanchPostMutation = (options?: Partial<Options<CreateRanchCreateRanchPostData>>) => {
    const mutationOptions: UseMutationOptions<CreateRanchCreateRanchPostResponse, AxiosError<CreateRanchCreateRanchPostError>, Options<CreateRanchCreateRanchPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createRanchCreateRanchPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const editRanchEditRanchPostQueryKey = (options: Options<EditRanchEditRanchPostData>) => [
    createQueryKey('editRanchEditRanchPost', options)
];

export const editRanchEditRanchPostOptions = (options: Options<EditRanchEditRanchPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await editRanchEditRanchPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: editRanchEditRanchPostQueryKey(options)
    });
};

export const editRanchEditRanchPostMutation = (options?: Partial<Options<EditRanchEditRanchPostData>>) => {
    const mutationOptions: UseMutationOptions<EditRanchEditRanchPostResponse, AxiosError<EditRanchEditRanchPostError>, Options<EditRanchEditRanchPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await editRanchEditRanchPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRanchesGetRanchesPostQueryKey = (options: Options<GetRanchesGetRanchesPostData>) => [
    createQueryKey('getRanchesGetRanchesPost', options)
];

export const getRanchesGetRanchesPostOptions = (options: Options<GetRanchesGetRanchesPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRanchesGetRanchesPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRanchesGetRanchesPostQueryKey(options)
    });
};

export const getRanchesGetRanchesPostMutation = (options?: Partial<Options<GetRanchesGetRanchesPostData>>) => {
    const mutationOptions: UseMutationOptions<GetRanchesGetRanchesPostResponse, AxiosError<GetRanchesGetRanchesPostError>, Options<GetRanchesGetRanchesPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getRanchesGetRanchesPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRanchesGeojsonGetRanchesGeojsonPostQueryKey = (options: Options<GetRanchesGeojsonGetRanchesGeojsonPostData>) => [
    createQueryKey('getRanchesGeojsonGetRanchesGeojsonPost', options)
];

export const getRanchesGeojsonGetRanchesGeojsonPostOptions = (options: Options<GetRanchesGeojsonGetRanchesGeojsonPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRanchesGeojsonGetRanchesGeojsonPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRanchesGeojsonGetRanchesGeojsonPostQueryKey(options)
    });
};

export const getRanchesGeojsonGetRanchesGeojsonPostMutation = (options?: Partial<Options<GetRanchesGeojsonGetRanchesGeojsonPostData>>) => {
    const mutationOptions: UseMutationOptions<GetRanchesGeojsonGetRanchesGeojsonPostResponse, AxiosError<GetRanchesGeojsonGetRanchesGeojsonPostError>, Options<GetRanchesGeojsonGetRanchesGeojsonPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getRanchesGeojsonGetRanchesGeojsonPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addParcelToRanchAddParcelToRanchPostQueryKey = (options: Options<AddParcelToRanchAddParcelToRanchPostData>) => [
    createQueryKey('addParcelToRanchAddParcelToRanchPost', options)
];

export const addParcelToRanchAddParcelToRanchPostOptions = (options: Options<AddParcelToRanchAddParcelToRanchPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addParcelToRanchAddParcelToRanchPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addParcelToRanchAddParcelToRanchPostQueryKey(options)
    });
};

export const addParcelToRanchAddParcelToRanchPostMutation = (options?: Partial<Options<AddParcelToRanchAddParcelToRanchPostData>>) => {
    const mutationOptions: UseMutationOptions<AddParcelToRanchAddParcelToRanchPostResponse, AxiosError<AddParcelToRanchAddParcelToRanchPostError>, Options<AddParcelToRanchAddParcelToRanchPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addParcelToRanchAddParcelToRanchPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteParcelFromRanchDeleteParcelFromRanchPostQueryKey = (options: Options<DeleteParcelFromRanchDeleteParcelFromRanchPostData>) => [
    createQueryKey('deleteParcelFromRanchDeleteParcelFromRanchPost', options)
];

export const deleteParcelFromRanchDeleteParcelFromRanchPostOptions = (options: Options<DeleteParcelFromRanchDeleteParcelFromRanchPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await deleteParcelFromRanchDeleteParcelFromRanchPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: deleteParcelFromRanchDeleteParcelFromRanchPostQueryKey(options)
    });
};

export const deleteParcelFromRanchDeleteParcelFromRanchPostMutation = (options?: Partial<Options<DeleteParcelFromRanchDeleteParcelFromRanchPostData>>) => {
    const mutationOptions: UseMutationOptions<DeleteParcelFromRanchDeleteParcelFromRanchPostResponse, AxiosError<DeleteParcelFromRanchDeleteParcelFromRanchPostError>, Options<DeleteParcelFromRanchDeleteParcelFromRanchPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteParcelFromRanchDeleteParcelFromRanchPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteRanchDeleteRanchPostQueryKey = (options: Options<DeleteRanchDeleteRanchPostData>) => [
    createQueryKey('deleteRanchDeleteRanchPost', options)
];

export const deleteRanchDeleteRanchPostOptions = (options: Options<DeleteRanchDeleteRanchPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await deleteRanchDeleteRanchPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: deleteRanchDeleteRanchPostQueryKey(options)
    });
};

export const deleteRanchDeleteRanchPostMutation = (options?: Partial<Options<DeleteRanchDeleteRanchPostData>>) => {
    const mutationOptions: UseMutationOptions<DeleteRanchDeleteRanchPostResponse, AxiosError<DeleteRanchDeleteRanchPostError>, Options<DeleteRanchDeleteRanchPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteRanchDeleteRanchPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getParcelsByRanchIdGetParcelsByRanchIdPostQueryKey = (options: Options<GetParcelsByRanchIdGetParcelsByRanchIdPostData>) => [
    createQueryKey('getParcelsByRanchIdGetParcelsByRanchIdPost', options)
];

export const getParcelsByRanchIdGetParcelsByRanchIdPostOptions = (options: Options<GetParcelsByRanchIdGetParcelsByRanchIdPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getParcelsByRanchIdGetParcelsByRanchIdPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getParcelsByRanchIdGetParcelsByRanchIdPostQueryKey(options)
    });
};

export const getParcelsByRanchIdGetParcelsByRanchIdPostMutation = (options?: Partial<Options<GetParcelsByRanchIdGetParcelsByRanchIdPostData>>) => {
    const mutationOptions: UseMutationOptions<GetParcelsByRanchIdGetParcelsByRanchIdPostResponse, AxiosError<GetParcelsByRanchIdGetParcelsByRanchIdPostError>, Options<GetParcelsByRanchIdGetParcelsByRanchIdPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getParcelsByRanchIdGetParcelsByRanchIdPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const querySoilsDetailUcdavisQuerySoilsDetailUcdavisPostQueryKey = (options: Options<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostData>) => [
    createQueryKey('querySoilsDetailUcdavisQuerySoilsDetailUcdavisPost', options)
];

export const querySoilsDetailUcdavisQuerySoilsDetailUcdavisPostOptions = (options: Options<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await querySoilsDetailUcdavisQuerySoilsDetailUcdavisPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: querySoilsDetailUcdavisQuerySoilsDetailUcdavisPostQueryKey(options)
    });
};

export const querySoilsDetailUcdavisQuerySoilsDetailUcdavisPostMutation = (options?: Partial<Options<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostData>>) => {
    const mutationOptions: UseMutationOptions<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostResponse, AxiosError<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostError>, Options<QuerySoilsDetailUcdavisQuerySoilsDetailUcdavisPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await querySoilsDetailUcdavisQuerySoilsDetailUcdavisPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSoilsPropsPtGetSoilsPropsPtPostQueryKey = (options: Options<GetSoilsPropsPtGetSoilsPropsPtPostData>) => [
    createQueryKey('getSoilsPropsPtGetSoilsPropsPtPost', options)
];

export const getSoilsPropsPtGetSoilsPropsPtPostOptions = (options: Options<GetSoilsPropsPtGetSoilsPropsPtPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSoilsPropsPtGetSoilsPropsPtPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSoilsPropsPtGetSoilsPropsPtPostQueryKey(options)
    });
};

export const getSoilsPropsPtGetSoilsPropsPtPostMutation = (options?: Partial<Options<GetSoilsPropsPtGetSoilsPropsPtPostData>>) => {
    const mutationOptions: UseMutationOptions<GetSoilsPropsPtGetSoilsPropsPtPostResponse, AxiosError<GetSoilsPropsPtGetSoilsPropsPtPostError>, Options<GetSoilsPropsPtGetSoilsPropsPtPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getSoilsPropsPtGetSoilsPropsPtPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const queryWatershedInfoPtQueryWatershedInfoPtPostQueryKey = (options: Options<QueryWatershedInfoPtQueryWatershedInfoPtPostData>) => [
    createQueryKey('queryWatershedInfoPtQueryWatershedInfoPtPost', options)
];

export const queryWatershedInfoPtQueryWatershedInfoPtPostOptions = (options: Options<QueryWatershedInfoPtQueryWatershedInfoPtPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await queryWatershedInfoPtQueryWatershedInfoPtPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: queryWatershedInfoPtQueryWatershedInfoPtPostQueryKey(options)
    });
};

export const queryWatershedInfoPtQueryWatershedInfoPtPostMutation = (options?: Partial<Options<QueryWatershedInfoPtQueryWatershedInfoPtPostData>>) => {
    const mutationOptions: UseMutationOptions<QueryWatershedInfoPtQueryWatershedInfoPtPostResponse, AxiosError<QueryWatershedInfoPtQueryWatershedInfoPtPostError>, Options<QueryWatershedInfoPtQueryWatershedInfoPtPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await queryWatershedInfoPtQueryWatershedInfoPtPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllLinksGetAllLinksPostQueryKey = (options: Options<GetAllLinksGetAllLinksPostData>) => [
    createQueryKey('getAllLinksGetAllLinksPost', options)
];

export const getAllLinksGetAllLinksPostOptions = (options: Options<GetAllLinksGetAllLinksPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllLinksGetAllLinksPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllLinksGetAllLinksPostQueryKey(options)
    });
};

export const getAllLinksGetAllLinksPostMutation = (options?: Partial<Options<GetAllLinksGetAllLinksPostData>>) => {
    const mutationOptions: UseMutationOptions<GetAllLinksGetAllLinksPostResponse, AxiosError<GetAllLinksGetAllLinksPostError>, Options<GetAllLinksGetAllLinksPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getAllLinksGetAllLinksPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateParcelsHsUpdateParcelsHsPostQueryKey = (options?: Options<UpdateParcelsHsUpdateParcelsHsPostData>) => [
    createQueryKey('updateParcelsHsUpdateParcelsHsPost', options)
];

export const updateParcelsHsUpdateParcelsHsPostOptions = (options?: Options<UpdateParcelsHsUpdateParcelsHsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await updateParcelsHsUpdateParcelsHsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: updateParcelsHsUpdateParcelsHsPostQueryKey(options)
    });
};

export const updateParcelsHsUpdateParcelsHsPostMutation = (options?: Partial<Options<UpdateParcelsHsUpdateParcelsHsPostData>>) => {
    const mutationOptions: UseMutationOptions<UpdateParcelsHsUpdateParcelsHsPostResponse, AxiosError<UpdateParcelsHsUpdateParcelsHsPostError>, Options<UpdateParcelsHsUpdateParcelsHsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateParcelsHsUpdateParcelsHsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllPortfolioSummariesGetAllPortfolioSummariesPostQueryKey = (options?: Options) => [
    createQueryKey('getAllPortfolioSummariesGetAllPortfolioSummariesPost', options)
];

export const getAllPortfolioSummariesGetAllPortfolioSummariesPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllPortfolioSummariesGetAllPortfolioSummariesPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllPortfolioSummariesGetAllPortfolioSummariesPostQueryKey(options)
    });
};

export const getAllPortfolioSummariesGetAllPortfolioSummariesPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<GetAllPortfolioSummariesGetAllPortfolioSummariesPostResponse, AxiosError<GetAllPortfolioSummariesGetAllPortfolioSummariesPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await getAllPortfolioSummariesGetAllPortfolioSummariesPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPortfolioSummaryGetPortfolioSummaryPostQueryKey = (options: Options<GetPortfolioSummaryGetPortfolioSummaryPostData>) => [
    createQueryKey('getPortfolioSummaryGetPortfolioSummaryPost', options)
];

export const getPortfolioSummaryGetPortfolioSummaryPostOptions = (options: Options<GetPortfolioSummaryGetPortfolioSummaryPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPortfolioSummaryGetPortfolioSummaryPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPortfolioSummaryGetPortfolioSummaryPostQueryKey(options)
    });
};

export const getPortfolioSummaryGetPortfolioSummaryPostMutation = (options?: Partial<Options<GetPortfolioSummaryGetPortfolioSummaryPostData>>) => {
    const mutationOptions: UseMutationOptions<GetPortfolioSummaryGetPortfolioSummaryPostResponse, AxiosError<GetPortfolioSummaryGetPortfolioSummaryPostError>, Options<GetPortfolioSummaryGetPortfolioSummaryPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getPortfolioSummaryGetPortfolioSummaryPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExecutiveSummaryGetExecutiveSummaryPostQueryKey = (options: Options<GetExecutiveSummaryGetExecutiveSummaryPostData>) => [
    createQueryKey('getExecutiveSummaryGetExecutiveSummaryPost', options)
];

export const getExecutiveSummaryGetExecutiveSummaryPostOptions = (options: Options<GetExecutiveSummaryGetExecutiveSummaryPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getExecutiveSummaryGetExecutiveSummaryPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getExecutiveSummaryGetExecutiveSummaryPostQueryKey(options)
    });
};

export const getExecutiveSummaryGetExecutiveSummaryPostMutation = (options?: Partial<Options<GetExecutiveSummaryGetExecutiveSummaryPostData>>) => {
    const mutationOptions: UseMutationOptions<GetExecutiveSummaryGetExecutiveSummaryPostResponse, AxiosError<GetExecutiveSummaryGetExecutiveSummaryPostError>, Options<GetExecutiveSummaryGetExecutiveSummaryPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getExecutiveSummaryGetExecutiveSummaryPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const insertReportInsertReportPostQueryKey = (options: Options<InsertReportInsertReportPostData>) => [
    createQueryKey('insertReportInsertReportPost', options)
];

export const insertReportInsertReportPostOptions = (options: Options<InsertReportInsertReportPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await insertReportInsertReportPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: insertReportInsertReportPostQueryKey(options)
    });
};

export const insertReportInsertReportPostMutation = (options?: Partial<Options<InsertReportInsertReportPostData>>) => {
    const mutationOptions: UseMutationOptions<InsertReportInsertReportPostResponse, AxiosError<InsertReportInsertReportPostError>, Options<InsertReportInsertReportPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await insertReportInsertReportPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const generateReportDownloadTokenGenerateReportDownloadTokenPostQueryKey = (options: Options<GenerateReportDownloadTokenGenerateReportDownloadTokenPostData>) => [
    createQueryKey('generateReportDownloadTokenGenerateReportDownloadTokenPost', options)
];

export const generateReportDownloadTokenGenerateReportDownloadTokenPostOptions = (options: Options<GenerateReportDownloadTokenGenerateReportDownloadTokenPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await generateReportDownloadTokenGenerateReportDownloadTokenPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generateReportDownloadTokenGenerateReportDownloadTokenPostQueryKey(options)
    });
};

export const generateReportDownloadTokenGenerateReportDownloadTokenPostMutation = (options?: Partial<Options<GenerateReportDownloadTokenGenerateReportDownloadTokenPostData>>) => {
    const mutationOptions: UseMutationOptions<GenerateReportDownloadTokenGenerateReportDownloadTokenPostResponse, AxiosError<GenerateReportDownloadTokenGenerateReportDownloadTokenPostError>, Options<GenerateReportDownloadTokenGenerateReportDownloadTokenPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await generateReportDownloadTokenGenerateReportDownloadTokenPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadReportDownloadReportTokenGetQueryKey = (options: Options<DownloadReportDownloadReportTokenGetData>) => [
    createQueryKey('downloadReportDownloadReportTokenGet', options)
];

export const downloadReportDownloadReportTokenGetOptions = (options: Options<DownloadReportDownloadReportTokenGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await downloadReportDownloadReportTokenGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: downloadReportDownloadReportTokenGetQueryKey(options)
    });
};

export const getReportByRanchIdGetReportByRanchIdPostQueryKey = (options: Options<GetReportByRanchIdGetReportByRanchIdPostData>) => [
    createQueryKey('getReportByRanchIdGetReportByRanchIdPost', options)
];

export const getReportByRanchIdGetReportByRanchIdPostOptions = (options: Options<GetReportByRanchIdGetReportByRanchIdPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReportByRanchIdGetReportByRanchIdPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getReportByRanchIdGetReportByRanchIdPostQueryKey(options)
    });
};

export const getReportByRanchIdGetReportByRanchIdPostMutation = (options?: Partial<Options<GetReportByRanchIdGetReportByRanchIdPostData>>) => {
    const mutationOptions: UseMutationOptions<GetReportByRanchIdGetReportByRanchIdPostResponse, AxiosError<GetReportByRanchIdGetReportByRanchIdPostError>, Options<GetReportByRanchIdGetReportByRanchIdPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getReportByRanchIdGetReportByRanchIdPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getReportByReportIdGetReportByReportIdPostQueryKey = (options: Options<GetReportByReportIdGetReportByReportIdPostData>) => [
    createQueryKey('getReportByReportIdGetReportByReportIdPost', options)
];

export const getReportByReportIdGetReportByReportIdPostOptions = (options: Options<GetReportByReportIdGetReportByReportIdPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReportByReportIdGetReportByReportIdPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getReportByReportIdGetReportByReportIdPostQueryKey(options)
    });
};

export const getReportByReportIdGetReportByReportIdPostMutation = (options?: Partial<Options<GetReportByReportIdGetReportByReportIdPostData>>) => {
    const mutationOptions: UseMutationOptions<GetReportByReportIdGetReportByReportIdPostResponse, AxiosError<GetReportByReportIdGetReportByReportIdPostError>, Options<GetReportByReportIdGetReportByReportIdPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getReportByReportIdGetReportByReportIdPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllReportsGetAllReportsPostQueryKey = (options: Options<GetAllReportsGetAllReportsPostData>) => [
    createQueryKey('getAllReportsGetAllReportsPost', options)
];

export const getAllReportsGetAllReportsPostOptions = (options: Options<GetAllReportsGetAllReportsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllReportsGetAllReportsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllReportsGetAllReportsPostQueryKey(options)
    });
};

export const getAllReportsGetAllReportsPostMutation = (options?: Partial<Options<GetAllReportsGetAllReportsPostData>>) => {
    const mutationOptions: UseMutationOptions<GetAllReportsGetAllReportsPostResponse, AxiosError<GetAllReportsGetAllReportsPostError>, Options<GetAllReportsGetAllReportsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getAllReportsGetAllReportsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFloodFromWktGetFloodFromWktPostQueryKey = (options: Options<GetFloodFromWktGetFloodFromWktPostData>) => [
    createQueryKey('getFloodFromWktGetFloodFromWktPost', options)
];

export const getFloodFromWktGetFloodFromWktPostOptions = (options: Options<GetFloodFromWktGetFloodFromWktPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFloodFromWktGetFloodFromWktPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFloodFromWktGetFloodFromWktPostQueryKey(options)
    });
};

export const getFloodFromWktGetFloodFromWktPostMutation = (options?: Partial<Options<GetFloodFromWktGetFloodFromWktPostData>>) => {
    const mutationOptions: UseMutationOptions<GetFloodFromWktGetFloodFromWktPostResponse, AxiosError<GetFloodFromWktGetFloodFromWktPostError>, Options<GetFloodFromWktGetFloodFromWktPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getFloodFromWktGetFloodFromWktPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStateDistrictsGetStateDistrictsPostQueryKey = (options: Options<GetStateDistrictsGetStateDistrictsPostData>) => [
    createQueryKey('getStateDistrictsGetStateDistrictsPost', options)
];

export const getStateDistrictsGetStateDistrictsPostOptions = (options: Options<GetStateDistrictsGetStateDistrictsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStateDistrictsGetStateDistrictsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getStateDistrictsGetStateDistrictsPostQueryKey(options)
    });
};

export const getStateDistrictsGetStateDistrictsPostMutation = (options?: Partial<Options<GetStateDistrictsGetStateDistrictsPostData>>) => {
    const mutationOptions: UseMutationOptions<GetStateDistrictsGetStateDistrictsPostResponse, AxiosError<GetStateDistrictsGetStateDistrictsPostError>, Options<GetStateDistrictsGetStateDistrictsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getStateDistrictsGetStateDistrictsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWeatherPlotsFromPtGetWeatherPlotsFromPtPostQueryKey = (options: Options<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostData>) => [
    createQueryKey('getWeatherPlotsFromPtGetWeatherPlotsFromPtPost', options)
];

export const getWeatherPlotsFromPtGetWeatherPlotsFromPtPostOptions = (options: Options<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWeatherPlotsFromPtGetWeatherPlotsFromPtPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWeatherPlotsFromPtGetWeatherPlotsFromPtPostQueryKey(options)
    });
};

export const getWeatherPlotsFromPtGetWeatherPlotsFromPtPostMutation = (options?: Partial<Options<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostData>>) => {
    const mutationOptions: UseMutationOptions<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostResponse, AxiosError<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostError>, Options<GetWeatherPlotsFromPtGetWeatherPlotsFromPtPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getWeatherPlotsFromPtGetWeatherPlotsFromPtPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostQueryKey = (options: Options<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostData>) => [
    createQueryKey('getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPost', options)
];

export const getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostOptions = (options: Options<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostQueryKey(options)
    });
};

export const getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostMutation = (options?: Partial<Options<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostData>>) => {
    const mutationOptions: UseMutationOptions<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostResponse, AxiosError<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostError>, Options<GetWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await getWeatherPlotsFromGeojsonGetWeatherPlotsFromGeojsonPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDwrNewsGetDwrNewsGetQueryKey = (options?: Options) => [
    createQueryKey('getDwrNewsGetDwrNewsGet', options)
];

export const getDwrNewsGetDwrNewsGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDwrNewsGetDwrNewsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDwrNewsGetDwrNewsGetQueryKey(options)
    });
};

export const getDwrNewsJsonGetDwrNewsJsonGetQueryKey = (options?: Options) => [
    createQueryKey('getDwrNewsJsonGetDwrNewsJsonGet', options)
];

export const getDwrNewsJsonGetDwrNewsJsonGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDwrNewsJsonGetDwrNewsJsonGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDwrNewsJsonGetDwrNewsJsonGetQueryKey(options)
    });
};

export const getDwrBlogsJsonGetDwrBlogsJsonGetQueryKey = (options?: Options) => [
    createQueryKey('getDwrBlogsJsonGetDwrBlogsJsonGet', options)
];

export const getDwrBlogsJsonGetDwrBlogsJsonGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDwrBlogsJsonGetDwrBlogsJsonGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDwrBlogsJsonGetDwrBlogsJsonGetQueryKey(options)
    });
};

export const geocodeGeocodeGetQueryKey = (options: Options<GeocodeGeocodeGetData>) => [
    createQueryKey('geocodeGeocodeGet', options)
];

export const geocodeGeocodeGetOptions = (options: Options<GeocodeGeocodeGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await geocodeGeocodeGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: geocodeGeocodeGetQueryKey(options)
    });
};

export const reverseGeocodeReverseGeocodeGetQueryKey = (options: Options<ReverseGeocodeReverseGeocodeGetData>) => [
    createQueryKey('reverseGeocodeReverseGeocodeGet', options)
];

export const reverseGeocodeReverseGeocodeGetOptions = (options: Options<ReverseGeocodeReverseGeocodeGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reverseGeocodeReverseGeocodeGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reverseGeocodeReverseGeocodeGetQueryKey(options)
    });
};

export const autocompleteAutocompleteGetQueryKey = (options: Options<AutocompleteAutocompleteGetData>) => [
    createQueryKey('autocompleteAutocompleteGet', options)
];

export const autocompleteAutocompleteGetOptions = (options: Options<AutocompleteAutocompleteGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await autocompleteAutocompleteGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: autocompleteAutocompleteGetQueryKey(options)
    });
};

export const placeDetailsPlaceDetailsGetQueryKey = (options: Options<PlaceDetailsPlaceDetailsGetData>) => [
    createQueryKey('placeDetailsPlaceDetailsGet', options)
];

export const placeDetailsPlaceDetailsGetOptions = (options: Options<PlaceDetailsPlaceDetailsGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await placeDetailsPlaceDetailsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: placeDetailsPlaceDetailsGetQueryKey(options)
    });
};

export const userFeedbackUserFeedbackPostQueryKey = (options: Options<UserFeedbackUserFeedbackPostData>) => [
    createQueryKey('userFeedbackUserFeedbackPost', options)
];

export const userFeedbackUserFeedbackPostOptions = (options: Options<UserFeedbackUserFeedbackPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await userFeedbackUserFeedbackPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userFeedbackUserFeedbackPostQueryKey(options)
    });
};

export const userFeedbackUserFeedbackPostMutation = (options?: Partial<Options<UserFeedbackUserFeedbackPostData>>) => {
    const mutationOptions: UseMutationOptions<UserFeedbackUserFeedbackPostResponse, AxiosError<UserFeedbackUserFeedbackPostError>, Options<UserFeedbackUserFeedbackPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await userFeedbackUserFeedbackPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const filterAutocompleteFilterAutocompletePostQueryKey = (options: Options<FilterAutocompleteFilterAutocompletePostData>) => [
    createQueryKey('filterAutocompleteFilterAutocompletePost', options)
];

export const filterAutocompleteFilterAutocompletePostOptions = (options: Options<FilterAutocompleteFilterAutocompletePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await filterAutocompleteFilterAutocompletePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: filterAutocompleteFilterAutocompletePostQueryKey(options)
    });
};

export const filterAutocompleteFilterAutocompletePostMutation = (options?: Partial<Options<FilterAutocompleteFilterAutocompletePostData>>) => {
    const mutationOptions: UseMutationOptions<FilterAutocompleteFilterAutocompletePostResponse, AxiosError<FilterAutocompleteFilterAutocompletePostError>, Options<FilterAutocompleteFilterAutocompletePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await filterAutocompleteFilterAutocompletePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apnAutocompleteApnAutocompletePostQueryKey = (options: Options<ApnAutocompleteApnAutocompletePostData>) => [
    createQueryKey('apnAutocompleteApnAutocompletePost', options)
];

export const apnAutocompleteApnAutocompletePostOptions = (options: Options<ApnAutocompleteApnAutocompletePostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apnAutocompleteApnAutocompletePost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apnAutocompleteApnAutocompletePostQueryKey(options)
    });
};

export const apnAutocompleteApnAutocompletePostMutation = (options?: Partial<Options<ApnAutocompleteApnAutocompletePostData>>) => {
    const mutationOptions: UseMutationOptions<ApnAutocompleteApnAutocompletePostResponse, AxiosError<ApnAutocompleteApnAutocompletePostError>, Options<ApnAutocompleteApnAutocompletePostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apnAutocompleteApnAutocompletePost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFilterCriteriaCountiesGetFilterCriteriaCountiesPostQueryKey = (options?: Options) => [
    createQueryKey('getFilterCriteriaCountiesGetFilterCriteriaCountiesPost', options)
];

export const getFilterCriteriaCountiesGetFilterCriteriaCountiesPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFilterCriteriaCountiesGetFilterCriteriaCountiesPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFilterCriteriaCountiesGetFilterCriteriaCountiesPostQueryKey(options)
    });
};

export const getFilterCriteriaCountiesGetFilterCriteriaCountiesPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostResponse, AxiosError<GetFilterCriteriaCountiesGetFilterCriteriaCountiesPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await getFilterCriteriaCountiesGetFilterCriteriaCountiesPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const filterCriteriaFilterCriteriaPostQueryKey = (options: Options<FilterCriteriaFilterCriteriaPostData>) => [
    createQueryKey('filterCriteriaFilterCriteriaPost', options)
];

export const filterCriteriaFilterCriteriaPostOptions = (options: Options<FilterCriteriaFilterCriteriaPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await filterCriteriaFilterCriteriaPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: filterCriteriaFilterCriteriaPostQueryKey(options)
    });
};

export const filterCriteriaFilterCriteriaPostMutation = (options?: Partial<Options<FilterCriteriaFilterCriteriaPostData>>) => {
    const mutationOptions: UseMutationOptions<FilterCriteriaFilterCriteriaPostResponse, AxiosError<FilterCriteriaFilterCriteriaPostError>, Options<FilterCriteriaFilterCriteriaPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await filterCriteriaFilterCriteriaPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createSubscriptionCreateSubscriptionPostQueryKey = (options?: Options) => [
    createQueryKey('createSubscriptionCreateSubscriptionPost', options)
];

export const createSubscriptionCreateSubscriptionPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createSubscriptionCreateSubscriptionPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createSubscriptionCreateSubscriptionPostQueryKey(options)
    });
};

export const createSubscriptionCreateSubscriptionPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<CreateSubscriptionCreateSubscriptionPostResponse, AxiosError<CreateSubscriptionCreateSubscriptionPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await createSubscriptionCreateSubscriptionPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const createCheckoutSessionCreateCheckoutSessionPostQueryKey = (options?: Options) => [
    createQueryKey('createCheckoutSessionCreateCheckoutSessionPost', options)
];

export const createCheckoutSessionCreateCheckoutSessionPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCheckoutSessionCreateCheckoutSessionPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createCheckoutSessionCreateCheckoutSessionPostQueryKey(options)
    });
};

export const createCheckoutSessionCreateCheckoutSessionPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<CreateCheckoutSessionCreateCheckoutSessionPostResponse, AxiosError<CreateCheckoutSessionCreateCheckoutSessionPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await createCheckoutSessionCreateCheckoutSessionPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const stripeWebhookStripeWebhookPostQueryKey = (options?: Options) => [
    createQueryKey('stripeWebhookStripeWebhookPost', options)
];

export const stripeWebhookStripeWebhookPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await stripeWebhookStripeWebhookPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: stripeWebhookStripeWebhookPostQueryKey(options)
    });
};

export const stripeWebhookStripeWebhookPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<StripeWebhookStripeWebhookPostResponse, AxiosError<StripeWebhookStripeWebhookPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await stripeWebhookStripeWebhookPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEnterpriseAdminGetEnterpriseAdminGetQueryKey = (options?: Options) => [
    createQueryKey('getEnterpriseAdminGetEnterpriseAdminGet', options)
];

export const getEnterpriseAdminGetEnterpriseAdminGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getEnterpriseAdminGetEnterpriseAdminGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEnterpriseAdminGetEnterpriseAdminGetQueryKey(options)
    });
};

export const getOrganizationUsersOrganizationOrganizationIdUsersGetQueryKey = (options: Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>) => [
    createQueryKey('getOrganizationUsersOrganizationOrganizationIdUsersGet', options)
];

export const getOrganizationUsersOrganizationOrganizationIdUsersGetOptions = (options: Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOrganizationUsersOrganizationOrganizationIdUsersGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOrganizationUsersOrganizationOrganizationIdUsersGetQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = queryKey[0];
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path,
            ...page.path
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query,
            ...page.query
        };
    }
    return params as unknown as typeof page;
};

export const getOrganizationUsersOrganizationOrganizationIdUsersGetInfiniteQueryKey = (options: Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>): QueryKey<Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>> => [
    createQueryKey('getOrganizationUsersOrganizationOrganizationIdUsersGet', options, true)
];

export const getOrganizationUsersOrganizationOrganizationIdUsersGetInfiniteOptions = (options: Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>) => {
    return infiniteQueryOptions<GetOrganizationUsersOrganizationOrganizationIdUsersGetResponse, AxiosError<GetOrganizationUsersOrganizationOrganizationIdUsersGetError>, InfiniteData<GetOrganizationUsersOrganizationOrganizationIdUsersGetResponse>, QueryKey<Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>>, number | Pick<QueryKey<Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetOrganizationUsersOrganizationOrganizationIdUsersGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getOrganizationUsersOrganizationOrganizationIdUsersGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOrganizationUsersOrganizationOrganizationIdUsersGetInfiniteQueryKey(options)
    });
};

export const createOrganizationUserOrganizationOrganizationIdUsersPostQueryKey = (options: Options<CreateOrganizationUserOrganizationOrganizationIdUsersPostData>) => [
    createQueryKey('createOrganizationUserOrganizationOrganizationIdUsersPost', options)
];

export const createOrganizationUserOrganizationOrganizationIdUsersPostOptions = (options: Options<CreateOrganizationUserOrganizationOrganizationIdUsersPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createOrganizationUserOrganizationOrganizationIdUsersPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createOrganizationUserOrganizationOrganizationIdUsersPostQueryKey(options)
    });
};

export const createOrganizationUserOrganizationOrganizationIdUsersPostMutation = (options?: Partial<Options<CreateOrganizationUserOrganizationOrganizationIdUsersPostData>>) => {
    const mutationOptions: UseMutationOptions<CreateOrganizationUserOrganizationOrganizationIdUsersPostResponse, AxiosError<CreateOrganizationUserOrganizationOrganizationIdUsersPostError>, Options<CreateOrganizationUserOrganizationOrganizationIdUsersPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createOrganizationUserOrganizationOrganizationIdUsersPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetQueryKey = (options: Options<ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetData>) => [
    createQueryKey('exportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGet', options)
];

export const exportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetOptions = (options: Options<ExportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await exportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: exportOrganizationUsersCsvOrganizationOrganizationIdUsersExportGetQueryKey(options)
    });
};

export const importOrganizationUsersOrganizationOrganizationIdUsersImportPostQueryKey = (options: Options<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostData>) => [
    createQueryKey('importOrganizationUsersOrganizationOrganizationIdUsersImportPost', options)
];

export const importOrganizationUsersOrganizationOrganizationIdUsersImportPostOptions = (options: Options<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await importOrganizationUsersOrganizationOrganizationIdUsersImportPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: importOrganizationUsersOrganizationOrganizationIdUsersImportPostQueryKey(options)
    });
};

export const importOrganizationUsersOrganizationOrganizationIdUsersImportPostMutation = (options?: Partial<Options<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostData>>) => {
    const mutationOptions: UseMutationOptions<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostResponse, AxiosError<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostError>, Options<ImportOrganizationUsersOrganizationOrganizationIdUsersImportPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await importOrganizationUsersOrganizationOrganizationIdUsersImportPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const autocompleteOrganizationOrganizationIdUsersAutocompleteGetQueryKey = (options: Options<AutocompleteOrganizationOrganizationIdUsersAutocompleteGetData>) => [
    createQueryKey('autocompleteOrganizationOrganizationIdUsersAutocompleteGet', options)
];

export const autocompleteOrganizationOrganizationIdUsersAutocompleteGetOptions = (options: Options<AutocompleteOrganizationOrganizationIdUsersAutocompleteGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await autocompleteOrganizationOrganizationIdUsersAutocompleteGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: autocompleteOrganizationOrganizationIdUsersAutocompleteGetQueryKey(options)
    });
};

export const getOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetQueryKey = (options: Options<GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetData>) => [
    createQueryKey('getOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGet', options)
];

export const getOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetOptions = (options: Options<GetOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOrganizationUserDetailOrganizationOrganizationIdUsersUseruuidGetQueryKey(options)
    });
};

export const updateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutMutation = (options?: Partial<Options<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutResponse, AxiosError<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutError>, Options<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOrganizationUserOrganizationOrganizationIdUsersUseruuidPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteMutation = (options?: Partial<Options<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteData>>) => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteResponse, AxiosError<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteError>, Options<UpdateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOrganizationUserOrganizationOrganizationIdUsersUseruuidDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutMutation = (options?: Partial<Options<UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutResponse, AxiosError<UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutError>, Options<UpdateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOrganizationUserActivationOrganizationOrganizationIdUsersUseruuidActivationPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostQueryKey = (options: Options<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostData>) => [
    createQueryKey('organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPost', options)
];

export const organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostOptions = (options: Options<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostQueryKey(options)
    });
};

export const organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostMutation = (options?: Partial<Options<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostData>>) => {
    const mutationOptions: UseMutationOptions<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostResponse, AxiosError<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostError>, Options<OrganizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await organizationUserPasswordResetOrganizationOrganizationIdUsersUseruuidPasswordResetPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostQueryKey = (options: Options<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostData>) => [
    createQueryKey('resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPost', options)
];

export const resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostOptions = (options: Options<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostQueryKey(options)
    });
};

export const resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostMutation = (options?: Partial<Options<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostData>>) => {
    const mutationOptions: UseMutationOptions<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostResponse, AxiosError<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostError>, Options<ResendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendInvitationOrganizationOrganizationIdUsersUseruuidResendInvitationPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const verifyInvitationVerifyInvitationTokenGetQueryKey = (options: Options<VerifyInvitationVerifyInvitationTokenGetData>) => [
    createQueryKey('verifyInvitationVerifyInvitationTokenGet', options)
];

export const verifyInvitationVerifyInvitationTokenGetOptions = (options: Options<VerifyInvitationVerifyInvitationTokenGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await verifyInvitationVerifyInvitationTokenGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: verifyInvitationVerifyInvitationTokenGetQueryKey(options)
    });
};

export const getOrganizationInfoOrganizationInfoGetQueryKey = (options?: Options) => [
    createQueryKey('getOrganizationInfoOrganizationInfoGet', options)
];

export const getOrganizationInfoOrganizationInfoGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOrganizationInfoOrganizationInfoGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOrganizationInfoOrganizationInfoGetQueryKey(options)
    });
};

export const updateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutMutation = (options?: Partial<Options<UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutResponse, AxiosError<UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutError>, Options<UpdateOrganizationInfoOrganizationOrganizationIdUpdateInfoPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateOrganizationInfoOrganizationOrganizationIdUpdateInfoPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutMutation = (options?: Partial<Options<UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutResponse, AxiosError<UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutError>, Options<UpdateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateBillingContactsOrganizationOrganizationIdUpdateBillingContactsPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostQueryKey = (options: Options<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostData>) => [
    createQueryKey('addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPost', options)
];

export const addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostOptions = (options: Options<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostQueryKey(options)
    });
};

export const addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostMutation = (options?: Partial<Options<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostData>>) => {
    const mutationOptions: UseMutationOptions<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostResponse, AxiosError<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostError>, Options<AddPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addPaymentMethodCardOrganizationOrganizationIdAddPaymentMethodCardPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPlaidLinkTokenGetPlaidLinkTokenGetQueryKey = (options?: Options) => [
    createQueryKey('getPlaidLinkTokenGetPlaidLinkTokenGet', options)
];

export const getPlaidLinkTokenGetPlaidLinkTokenGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlaidLinkTokenGetPlaidLinkTokenGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPlaidLinkTokenGetPlaidLinkTokenGetQueryKey(options)
    });
};

export const addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostQueryKey = (options: Options<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostData>) => [
    createQueryKey('addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPost', options)
];

export const addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostOptions = (options: Options<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostQueryKey(options)
    });
};

export const addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostMutation = (options?: Partial<Options<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostData>>) => {
    const mutationOptions: UseMutationOptions<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostResponse, AxiosError<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostError>, Options<AddPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const removePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteMutation = (options?: Partial<Options<RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteData>>) => {
    const mutationOptions: UseMutationOptions<RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteResponse, AxiosError<RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteError>, Options<RemovePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await removePaymentMethodOrganizationOrganizationIdDeletePaymentMethodPaymentMethodIdDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutMutation = (options?: Partial<Options<UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutResponse, AxiosError<UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutError>, Options<UpdateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBillingHistoryOrganizationOrganizationIdBillingHistoryGetQueryKey = (options: Options<GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetData>) => [
    createQueryKey('getBillingHistoryOrganizationOrganizationIdBillingHistoryGet', options)
];

export const getBillingHistoryOrganizationOrganizationIdBillingHistoryGetOptions = (options: Options<GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBillingHistoryOrganizationOrganizationIdBillingHistoryGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getBillingHistoryOrganizationOrganizationIdBillingHistoryGetQueryKey(options)
    });
};

export const downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetQueryKey = (options: Options<DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetData>) => [
    createQueryKey('downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGet', options)
];

export const downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetOptions = (options: Options<DownloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: downloadAllInvoicesOrganizationOrganizationIdDownloadAllInvoicesGetQueryKey(options)
    });
};

export const socialiteCallBackSocialiteCallbackProviderPostQueryKey = (options: Options<SocialiteCallBackSocialiteCallbackProviderPostData>) => [
    createQueryKey('socialiteCallBackSocialiteCallbackProviderPost', options)
];

export const socialiteCallBackSocialiteCallbackProviderPostOptions = (options: Options<SocialiteCallBackSocialiteCallbackProviderPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await socialiteCallBackSocialiteCallbackProviderPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: socialiteCallBackSocialiteCallbackProviderPostQueryKey(options)
    });
};

export const socialiteCallBackSocialiteCallbackProviderPostMutation = (options?: Partial<Options<SocialiteCallBackSocialiteCallbackProviderPostData>>) => {
    const mutationOptions: UseMutationOptions<SocialiteCallBackSocialiteCallbackProviderPostResponse, AxiosError<SocialiteCallBackSocialiteCallbackProviderPostError>, Options<SocialiteCallBackSocialiteCallbackProviderPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await socialiteCallBackSocialiteCallbackProviderPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const inAppVerifyReceiptInAppVerifyReceiptPostQueryKey = (options: Options<InAppVerifyReceiptInAppVerifyReceiptPostData>) => [
    createQueryKey('inAppVerifyReceiptInAppVerifyReceiptPost', options)
];

export const inAppVerifyReceiptInAppVerifyReceiptPostOptions = (options: Options<InAppVerifyReceiptInAppVerifyReceiptPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await inAppVerifyReceiptInAppVerifyReceiptPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: inAppVerifyReceiptInAppVerifyReceiptPostQueryKey(options)
    });
};

export const inAppVerifyReceiptInAppVerifyReceiptPostMutation = (options?: Partial<Options<InAppVerifyReceiptInAppVerifyReceiptPostData>>) => {
    const mutationOptions: UseMutationOptions<InAppVerifyReceiptInAppVerifyReceiptPostResponse, AxiosError<InAppVerifyReceiptInAppVerifyReceiptPostError>, Options<InAppVerifyReceiptInAppVerifyReceiptPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await inAppVerifyReceiptInAppVerifyReceiptPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appleNotificationAppleNotificationPostQueryKey = (options?: Options) => [
    createQueryKey('appleNotificationAppleNotificationPost', options)
];

export const appleNotificationAppleNotificationPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appleNotificationAppleNotificationPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appleNotificationAppleNotificationPostQueryKey(options)
    });
};

export const appleNotificationAppleNotificationPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<AppleNotificationAppleNotificationPostResponse, AxiosError<AppleNotificationAppleNotificationPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await appleNotificationAppleNotificationPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appleNotificationTestAppleNotificationTestPostQueryKey = (options?: Options) => [
    createQueryKey('appleNotificationTestAppleNotificationTestPost', options)
];

export const appleNotificationTestAppleNotificationTestPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appleNotificationTestAppleNotificationTestPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appleNotificationTestAppleNotificationTestPostQueryKey(options)
    });
};

export const appleNotificationTestAppleNotificationTestPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<AppleNotificationTestAppleNotificationTestPostResponse, AxiosError<AppleNotificationTestAppleNotificationTestPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await appleNotificationTestAppleNotificationTestPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const appleNotificationTestAppleNotificationTestGetQueryKey = (options?: Options<AppleNotificationTestAppleNotificationTestGetData>) => [
    createQueryKey('appleNotificationTestAppleNotificationTestGet', options)
];

export const appleNotificationTestAppleNotificationTestGetOptions = (options?: Options<AppleNotificationTestAppleNotificationTestGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await appleNotificationTestAppleNotificationTestGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: appleNotificationTestAppleNotificationTestGetQueryKey(options)
    });
};

export const googleNotificationGoogleNotificationPostQueryKey = (options?: Options) => [
    createQueryKey('googleNotificationGoogleNotificationPost', options)
];

export const googleNotificationGoogleNotificationPostOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await googleNotificationGoogleNotificationPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: googleNotificationGoogleNotificationPostQueryKey(options)
    });
};

export const googleNotificationGoogleNotificationPostMutation = (options?: Partial<Options>) => {
    const mutationOptions: UseMutationOptions<GoogleNotificationGoogleNotificationPostResponse, AxiosError<GoogleNotificationGoogleNotificationPostError>, Options> = {
        mutationFn: async (localOptions) => {
            const { data } = await googleNotificationGoogleNotificationPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPlanFeatureSettingsPlanFeatureSettingsGetQueryKey = (options?: Options) => [
    createQueryKey('getPlanFeatureSettingsPlanFeatureSettingsGet', options)
];

export const getPlanFeatureSettingsPlanFeatureSettingsGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlanFeatureSettingsPlanFeatureSettingsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPlanFeatureSettingsPlanFeatureSettingsGetQueryKey(options)
    });
};

export const adminGetPlanFeatureSettingsAdminPlanFeatureSettingsGetQueryKey = (options?: Options) => [
    createQueryKey('adminGetPlanFeatureSettingsAdminPlanFeatureSettingsGet', options)
];

export const adminGetPlanFeatureSettingsAdminPlanFeatureSettingsGetOptions = (options?: Options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminGetPlanFeatureSettingsAdminPlanFeatureSettingsGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminGetPlanFeatureSettingsAdminPlanFeatureSettingsGetQueryKey(options)
    });
};

export const adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostQueryKey = (options: Options<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostData>) => [
    createQueryKey('adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPost', options)
];

export const adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostOptions = (options: Options<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostQueryKey(options)
    });
};

export const adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostMutation = (options?: Partial<Options<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostData>>) => {
    const mutationOptions: UseMutationOptions<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostResponse, AxiosError<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostError>, Options<AdminSavePlanFeatureSettingsAdminPlanFeatureSettingsPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await adminSavePlanFeatureSettingsAdminPlanFeatureSettingsPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const updateUserNotifyHsChangeUsersNotifyHsChangePutMutation = (options?: Partial<Options<UpdateUserNotifyHsChangeUsersNotifyHsChangePutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateUserNotifyHsChangeUsersNotifyHsChangePutResponse, AxiosError<UpdateUserNotifyHsChangeUsersNotifyHsChangePutError>, Options<UpdateUserNotifyHsChangeUsersNotifyHsChangePutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateUserNotifyHsChangeUsersNotifyHsChangePut({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};